const PRODUCTION_ORIGINS = new Set([
  'https://doroparty.com',
  'https://www.doroparty.com',
]);

export function realtimeAllowedForCurrentOrigin() {
  if (typeof window === 'undefined') return true;
  const origin = String(window.location.origin || '');
  if (PRODUCTION_ORIGINS.has(origin)) return true;
  if (/^http:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?$/i.test(origin)) return true;
  try {
    const hostname = new URL(origin).hostname;
    return /^(?:[a-z0-9-]+-)?dororaid\.kukla1255\.workers\.dev$/i.test(hostname);
  } catch {
    return false;
  }
}
